import React from 'react';
import { MathJax, MathJaxContext } from 'better-react-mathjax';
import { GPAHelperTextLang } from './GPAHelperTextLang';

export const GPAHelperPage: React.FC = () => {
  const CGPAformula = `\\text{CGPA} = \\frac{\\sum (\\text{Grade Points} \\times \\text{No. of Course Credit Points of EACH course taken in the programme}) \\text{}}{\\text{Total no. of Credit Points in the programme}}`;
  const AVGMformula = `\\text{Average Mark} = \\frac{\\sum (\\text{Mark of EACH course taken in the programme}  \\text{}) \\text{}}{\\text{Total no. of courses taken in the programme}}`;

  const grades = ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D'];
  const gradePoints = [4.3, 4.0, 3.7, 3.3, 3.0, 2.7, 2.3, 2.0, 1.7, 1.3, 1.0];

  const thTdStyle = {
    border: '1px solid black',
    padding: '8px',
  };

  return (
    <MathJaxContext>
      <MathJax>
        <div className="w-full flex flex-col px-12 py-8">
          <div>
            <h1 className="font-serif my-2 font-bold text-lg underline decoration-1">
              {GPAHelperTextLang.CGPA}
            </h1>
            <h1 className="font-serif my-2 ml-8">
              {GPAHelperTextLang.CGPA_INTRO}
            </h1>
            <div
              className="my-12 justify-center flex"
              style={{ fontSize: '22px' }}
            >{`\\( ${CGPAformula} \\)`}</div>
            <h1 className="font-serif my-2 ml-8">
              {GPAHelperTextLang.CGPA_OUT_OF}
            </h1>
          </div>
          <div>
            <h1 className="font-serif my-2 font-bold text-lg underline decoration-1">
              {GPAHelperTextLang.AVGM}
            </h1>
            <h1 className="font-serif my-2 ml-8">
              {GPAHelperTextLang.AVGM_INTRO}
            </h1>
            <div
              className="my-12 justify-center flex"
              style={{ fontSize: '22px' }}
            >{`\\( ${AVGMformula} \\)`}</div>
            <h1 className="font-serif my-2 ml-8">
              {GPAHelperTextLang.AVGM_OUT_OF}
            </h1>
          </div>

          <div>
            <h1 className="font-serif my-2 font-bold text-lg underline decoration-1">
              {GPAHelperTextLang.AVGG}
            </h1>
            <h1 className="font-serif my-2 ml-8">
              {GPAHelperTextLang.AVGG_INTRO}
            </h1>
            <div
              className="my-12 justify-center flex"
              style={{ fontSize: '18px' }}
            >
              {' '}
              <table border={1} cellPadding="5" cellSpacing="0">
                <thead>
                  <tr>
                    <th style={thTdStyle}>Grade</th>
                    {grades.map((grade, index) => (
                      <th style={thTdStyle} key={index}>
                        {grade}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={thTdStyle}>Grade Points</td>
                    {gradePoints.map((point, index) => (
                      <td style={thTdStyle} key={index}>
                        {point}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
            <h1
              className="font-serif justify-center flex mt-24 text-lg cursor-pointer underline decoration-1"
              onClick={() => {
                window.close();
              }}
            >
              {GPAHelperTextLang.CLOSE}
            </h1>
          </div>
        </div>
      </MathJax>{' '}
    </MathJaxContext>
  );
};
